module.exports = ng.material.select;